import { Field } from '@awp/http';

export interface FieldMap {
  defaultValue?: any;
  mapValue?(model: any, field: Field): any;
}

export interface Adaptor<TSource, TDestination> {
  convert(model: TSource): TDestination;
  addFieldMap(fieldName: string, fieldMap: FieldMap): void;
  actionName?: string;
  addFields(fields: Field[]): void;
}

export abstract class BaseModelAdaptor<TSource = any, TDestination = any> implements Adaptor<TSource, TDestination> {

  private readonly _fieldMaps = new Map<string, FieldMap>();
  private _fields: Field[];

  constructor() {
    this.registerFieldMaps();
  }

  /* Convert model to request field mapping */
  public convert(model: TSource): TDestination;
  public convert<TResult>(model: TSource): TResult;
  public convert(model: any): any {
    if (this._fields == null) {
      console.error('No fields for adaptor');
      return null;
    }

    const entity = this._fields.reduce((map, field) => (map[field.name] = this.mapField(model, field), map), {}) as TDestination;
    return entity;
  }

  addFields(fields: Field[]): void {
    this._fields = fields;
  }

  public addFieldMap(fieldName: string, fieldMap: FieldMap): void {
    this._fieldMaps.set(fieldName, fieldMap);
  }

  abstract registerFieldMaps(): void;

  /* Map each field identifier and pluck field from model */
  protected mapField(model: TSource, field: Field): any {
    try {
      let value: any = null;
      const fieldMap = this._fieldMaps.get(field.name);
      if (fieldMap != null) {
        if (fieldMap.mapValue != null) {
          value = fieldMap.mapValue(model, field);
        }
        value = value != null ? value : fieldMap.defaultValue;
      }

      return value;
    } catch (err) {
      console.error('Error mapping field', field);
      return undefined;
    }
  }
}
